"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCalleeFnName = getCalleeFnName;
exports.onRequestGlobal = onRequestGlobal;
exports.onResponseGlobal = onResponseGlobal;
exports["default"] = onCallGlobal;
exports.apiCallCounter = void 0;

var _makeCounter = require("../misc/makeCounter");

var _errors = require("../../errors");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var apiCallCounter = (0, _makeCounter.makeCounter)();
exports.apiCallCounter = apiCallCounter;

function getCalleeFnName(callee) {
  return callee && callee.name ? "".concat(callee.name.toString()) : null;
}

function onRequestGlobal(client, promise, apiCall) {
  var _client$globalApiCall;

  var onRequest = (_client$globalApiCall = client.globalApiCallbacks) === null || _client$globalApiCall === void 0 ? void 0 : _client$globalApiCall.onRequest;

  if (onRequest) {
    var apiCallState = {
      promise: promise,
      clientState: client.getState()
    };

    var apiCallRequest = _objectSpread({}, apiCall, {}, apiCallState); // invoke client.globalApiCallbacks.onRequest if it exists


    onRequest(apiCallRequest);
  }
}

function onResponseGlobal(client, promise, apiCall, payload, apiError) {
  var _client$globalApiCall2;

  var onResponse = (_client$globalApiCall2 = client.globalApiCallbacks) === null || _client$globalApiCall2 === void 0 ? void 0 : _client$globalApiCall2.onResponse;

  if (onResponse) {
    var apiCallState = {
      promise: promise,
      clientState: client.getState()
    };

    var apiCallResponse = _objectSpread({}, apiCall, {}, apiCallState, {
      payload: payload,
      apiError: apiError
    }); // invoke client.globalApiCallbacks.onResponse if it exists


    onResponse(apiCallResponse);
  }
}
/**
  onCallGlobal
  - This handler enables us to have "global" callbacks that get invoked on every
    api call request and response event. This is useful for things like global error handling
    (e.g. if any response returns a 429, trigger a particular UI flow)
  - Usage: createCall.js call object exposes setters to the consuming application:
    call.setOnRequest to set global onRequest callback on the client.globalApiCallbacks object
    call.setOnResponse to set global onResponse callback on the client.globalApiCallbacks object
  - The promise param should be an instance of a promise returned by callWithCallback or callWithPromise
  - Invokes client.globalApiCallbacks.onRequest immediately (if it is defined)
  - Invokes client.globalApiCallbacks.onResponse when the response returns (if it is defined)
 */


function onCallGlobal(client, callee, calleeArgs, promise) {
  // functionName example: 'getApiAccount'
  var functionName = getCalleeFnName(callee);
  var apiCallCount = apiCallCounter(); // apiCallId example: 'getApiAccount-4'
  // apiCallId example if functionName is null (for some reason): '4'

  var apiCallId = [functionName, apiCallCount].join('-');
  var apiCall = {
    functionName: functionName,
    functionArgs: calleeArgs,
    apiCallId: apiCallId
  };
  onRequestGlobal(client, promise, apiCall); // Start a new promise chain from the original promise using Promise.race()
  // to ensure we don't interfere with the invoked call's existing promise chain

  return Promise.race([promise]).then(function (payload) {
    onResponseGlobal(client, promise, apiCall, payload);
  })["catch"](function (apiError) {
    var payload = apiError;
    onResponseGlobal(client, promise, apiCall, payload, apiError);
  });
}